import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import Modal from '../Modal';
import Icon, { GLYPHS } from '../icon';
import { t } from '../../../modules/infra/i18n';

const SetupPaymentInfoModal = ({
  onCloseHandler,
  onSetupPaymentInfoHandler,
  isOpen,
  isUSBased,
}) => (
  <Modal close={onCloseHandler} className="c-stripe-info-modal c-modal-new" showCloseButton display-if={isOpen}>
    <div className="o-flexbox o-flexbox--content-align-center o-flexbox--column u-p+">
      <Icon glyph={GLYPHS.capital} size="large" className="c-modal-new__header-icon" />
      <div className="c-modal-new__header">{t('register:setup_payment_modal.header')}</div>

      {isUSBased ? (
        <Fragment>
          <p className="c-modal-new__text">{t('register:setup_payment_modal.us_description_1')}</p>

          <p className="c-modal-new__text">
            {t('register:setup_payment_modal.us_description_2')}
          </p>
        </Fragment>
      ) : (
        <Fragment>
          <p className="c-modal-new__text">{t('register:setup_payment_modal.non_us_description_1')}</p>

          <p className="c-modal-new__text">{t('register:setup_payment_modal.non_us_description_2')}</p>
        </Fragment>
      )}

      <button
        className="c-btn c-btn--medium u-mt+ u-width-100"
        onClick={onSetupPaymentInfoHandler}
      >
        {t('register:setup_payment_modal.setup_button')}
      </button>
    </div>
  </Modal>
);

SetupPaymentInfoModal.propTypes = {
  onCloseHandler: PropTypes.func,
  onSetupPaymentInfoHandler: PropTypes.func,
  isOpen: PropTypes.bool,
  isUSBased: PropTypes.bool.isRequired,
};

SetupPaymentInfoModal.defaultProps = {
  isOpen: false,
  onCloseHandler: noop,
  onSetupPaymentInfoHandler: noop,
};

export default SetupPaymentInfoModal;
